import { render, staticRenderFns } from "./ArticleForm.vue?vue&type=template&id=0079197c"
import script from "./ArticleForm.vue?vue&type=script&lang=js"
export * from "./ArticleForm.vue?vue&type=script&lang=js"
import style0 from "./ArticleForm.vue?vue&type=style&index=0&id=0079197c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports